import { TargetDecisionScope } from '@/models/adobe-target';
import { WebInteraction } from './models'

// Since we don't have types for the tag groups, using tag group id to identify
// dietary exclusion tags
export const  dietaryExclusionTagGroupId = 'fb18dec3-ce3f-46e0-a9ea-0319da131c61'; 

export const HOME_PAGE_DECISION_SCOPES = [
    TargetDecisionScope.DualPromoBanner,
    TargetDecisionScope.FeaturedMeals,
    TargetDecisionScope.HeroPromoBannerTop,
    TargetDecisionScope.LargePromoOrder,
    TargetDecisionScope.LoyaltyBannerHomePage,
    TargetDecisionScope.HomePageSectionOrder,
    TargetDecisionScope.TopLevelMenu
];
  
export const MEAL_BUILDER_DECISION_SCOPES = [
    TargetDecisionScope.MealBuilderProteinOrder,
];

export const ORDER_CONFIRMATION_DECISION_SCOPES = [
    TargetDecisionScope.OrderConfirmationGuest
];

export const USER_PROFILE_DECISION_SCOPES = [
    TargetDecisionScope.CartUpsellItems,
]

export const HeaderLinkWebInteractions: { [name: string]: WebInteraction } = {
    Logo: {
        linkClicks: {value: 1},
        linkSection: 'header',
        linkPosition: null,
        linkCategory: 'home',
        linkName: 'cmg-logo',
        linkTitle: '(no-title)',
    },
    SignIn: {
        linkClicks: {value: 1},
        linkSection: 'header',
        linkPosition: null,
        linkCategory: 'account',
        linkName: 'account',
        linkTitle: 'sign-in',
    },
    Hey: {
        linkClicks: {value: 1},
        linkSection: 'header',
        linkPosition: null,
        linkCategory: 'account',
        linkName: 'account',
        linkTitle: 'hey',
    },
    Order:  {
        linkClicks: {value: 1},
        linkSection: 'header',
        linkPosition: null,
        linkCategory: 'order-menu',
        linkName: 'order',
        linkTitle: '(no-title)',
    },
    Catering:  {
        linkClicks: {value: 1},
        linkSection: 'header',
        linkPosition: null,
        linkCategory: 'catering',
        linkName: 'catering',
        linkTitle: '(no-title)',
    },
    Rewards:  {
        linkClicks: {value: 1},
        linkSection: 'header',
        linkPosition: null,
        linkCategory: 'rewards',
        linkName: 'rewards',
        linkTitle: '(no-title)',
    },
    Values:  {
        linkClicks: {value: 1},
        linkSection: 'header',
        linkPosition: null,
        linkCategory: 'branding-values',
        linkName: 'our-values',
        linkTitle: '(no-title)',
    },
    Nutrition:  {
        linkClicks: {value: 1},
        linkSection: 'header',
        linkPosition: null,
        linkCategory: 'nutrition',
        linkName: 'nutrition',
        linkTitle: '(no-title)',
    },
    FAC:  {
        linkClicks: {value: 1},
        linkSection: 'header',
        linkPosition: null,
        linkCategory: 'fac',
        linkName: 'find-a-chipotle',
        linkTitle: '(no-title)',
    },
    Bag:  {
        linkClicks: {value: 1},
        linkSection: 'header',
        linkPosition: null,
        linkCategory: 'order-open-bag',
        linkName: 'bag',
        linkTitle: '(no-title)',
    },
}

export const HomePageLinkInteractions: { [name: string]: WebInteraction } = {
    LoyaltyBannerCreateAccount: {
        linkClicks: {value: 1},
        linkSection: 'loyalty-banner-homepage',
        linkPosition: null,
        linkCategory: 'account',
        linkName: 'create-account',
        linkTitle: '(no-title)',
    },
    LoyaltyBannerSignIn: {
        linkClicks: {value: 1},
        linkSection: 'loyalty-banner-homepage',
        linkPosition: null,
        linkCategory: 'account',
        linkName: 'sign-in',
        linkTitle: '(no-title)',
    },
    TopLevelMenuItem: {
        linkClicks: {value: 1},
        linkSection: 'top-level-menu',
        linkPosition: null,
        linkCategory: 'order-build',
        linkName: 'order',
        linkTitle: '(no-title)',
    },
    FeaturedMealsFindAChipotle: {
        linkClicks: {value: 1},
        linkSection: 'featured-meals',
        linkPosition: '01',
        linkCategory: 'fac',
        linkName: 'find-a-chipotle',
        linkTitle: '(no-title)',
    },
    FeaturedMealsAddToBag: {
        linkClicks: {value: 1},
        linkSection: 'featured-meals',
        linkPosition: null,
        linkCategory: 'order-add-to-bag',
        linkName: 'add-to-bag',
        linkTitle: '(no-title)',
    },
    FeaturedMealsMakeItMyOwn: {
        linkClicks: {value: 1},
        linkSection: 'featured-meals',
        linkPosition: null,
        linkCategory: 'order-build',
        linkName: 'make-it-my-own',
        linkTitle: '(no-title)',
    },
    HeroBannerOrderNow: {
        linkClicks: {value: 1},
        linkSection: 'hero-promo-banner-top',
        linkPosition: null,
        linkCategory: '',
        linkName: '',
        linkTitle: ''
    },
    SecondaryToutsOrderNow: {
        linkClicks: {value: 1},
        linkSection: 'dual-promo-banner',
        linkPosition: null,
        linkCategory: '',
        linkName: '',
        linkTitle: ''
    },
    CrowdPleasersTout: {
        linkClicks: {value: 1},
        linkSection: 'large-order-promo',
        linkPosition: 2,
        linkCategory: '',
        linkName: '',
        linkTitle: '',
    }
}

export const ExternalLinkReferrer: WebInteraction = {
    linkClicks: {value: 0},
    linkSection: '(external)',
    linkPosition: '(external)',
    linkCategory: '(external)',
    linkName: '(external)',
    linkTitle: '(external)',
}

export const CreateAccountStart: WebInteraction = {      
    name: 'registrationStart',
    linkClicks: {value: 1},
    type: 'other',
    linkModuleName: 'Account|Create Account Modal|Create Account Start'
}

export const EmptyLinkInteraction: WebInteraction = {
    linkClicks: {value: 0},
    linkSection: '',
    linkPosition: '',
    linkCategory: '',
    linkName: '',
    linkTitle: '',
}

export const AddToBagWebInteraction: WebInteraction = {
    linkClicks: {value: 1},
    linkCategory: 'order-add-to-bag',
    linkName: 'add-to-bag',
}

export const enum RetrievalType {
    Delivery = 'delivery',
    Pickup = 'pickup'
}
